<template>
  <div ref="tableWrapper">
    <div
      :class="{ 'border-common': showBorder }"
      class="table-wrapper"
      style="height: 100%"
    >
      <img
        :src="require(`@/assets/img/border/left-bottom-border.png`)"
        class="border-left-bottom"
        v-if="showBorder"
      />
      <img
        :src="require(`@/assets/img/border/right-bottom-border.png`)"
        class="border-right-bottom"
        v-if="showBorder"
      />
      <img
        :src="require(`@/assets/img/border/right-top-border.png`)"
        class="border-right-top"
        v-if="showBorder"
      />
      <el-table
        v-loading="options.loading"
        :data="dataSource"
        :max-height="options.maxHeight"
        :stripe="options.stripe"
        :border="options.border"
        :height="options.height"
        :default-sort="defaultSort"
        :show-header="options.showHeader"
        :show-summary="showSummary"
        :highlight-current-row="options.highlightCurrentRow"
        :row-key="rowKey"
        :tree-props="treeProps"
        :default-expand-all="defaultExpandAll"
        :span-method="options.spanMethod"
        @select="handleSelectChange"
        @selection-change="handleSelectionChange"
        @select-all="handleSelectAll"
        @sort-change="handleSortChange"
        @row-click="handleRowClick"
        class="r-table"
        style="width: 100%"
        ref="table"
      >
        <!--选择框-->
        <el-table-column
          v-if="options.mutiSelect || options.multiSelect || options.selection"
          type="selection"
          style="width: 50px"
          align="center"
          :labelClassName="
            options.theadSelectionNone ? 'thead-selection-none' : ''
          "
        ></el-table-column>

        <!--序号-->
        <el-table-column
          v-if="options.serialNum"
          :fixed="options.serialNum === 'fixed'"
          label="序号"
          type="index"
          :width="options.serialNumWidth || '50'"
          align="center"
          :index="indexMethod"
        ></el-table-column>

        <!--数据列表-->
        <slot>
          <template v-for="column in columns">
            <r-table-column
              v-if="column.visible !== false || column.disabled"
              :column="column"
              :options="options"
              :key="'rcol_' + column.prop"
            ></r-table-column>
          </template>
        </slot>
      </el-table>
      <!--分页-->
      <RPagination
        :pagination="pagination"
        @current-change="handlePageChange"
        v-if="showPagination"
      />
    </div>
  </div>
</template>

<script>
import RPagination from './RPagination'
import RTableColumn from '@/components/common/RTableColumn'

export default {
  components: {
    RTableColumn,
    RPagination,
    RenderDom: {
      // functional: true,
      props: {
        scope: Object,
        row: Object,
        index: Number,
        render: Function,
        column: Object
      },
      render(createElement, self) {
        const { row, index, column, scope } = self.props
        return self.props.render(row, index, column, scope)
      }
    }
  },
  props: {
    dataSource: Array, // 表格数据
    options: {
      type: Object,
      default: {}
    }, // 表格参数 maxHeight、border
    columns: Array, //
    pagination: Object, // 分页
    defaultSort: Object,
    showBorder: Boolean,
    showSummary: Boolean,
    showPagination: {
      type: Boolean,
      default: true
    },
    rowKey: String,
    treeProps: Object,
    defaultExpandAll: Boolean
  },
  created() {
    // 默认设置
    this.$parent.options = Object.assign(this.options, {
      //stripe: true, // 是否为斑马纹
      border: false, // 是否有border
      expand: false // 是否有展开行
    })
  },
  mounted() {
    this.setTableHeight()
    window.addEventListener('resize', () => {
      this.$nextTick(() => {
        this.setTableHeight()
      })
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.$nextTick(() => {
        this.setTableHeight()
      })
    })
  },
  methods: {
    setTableHeight() {
      if (this.options.calculateHeight) {
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.$refs.tableWrapper) {
              let top = this.$refs.tableWrapper.getBoundingClientRect().top
              let height = document.body.clientHeight - top - (this.pagination ? 60 : 26)
              this.options.height = height
            }
          }, 100)
        })
      }
    },
    handleSelectionChange(selection) {
      this.$emit('selection-change', selection)
      if (this.options.selection) {
        this.options.selection = selection
      }
    },
    handleSelectAll(selection) {
      this.$emit('select-all', selection)
      /*if (this.options.selection) {
        this.options.selection = selection
      }*/
    },
    handleSelectChange(selection, row) {
      this.$emit('select', selection, row)
    },
    handleRowClick(row, event, column) {
      this.$emit('row-click', row, event, column)
    },
    handlePageChange(val, ops) {
      this.$emit('current-change', val, ops)
    },
    indexMethod(index) {
      if (this.pagination) {
        return index + (this.pagination.pageIndex - 1) * this.pagination.pageSize + 1
      } else {
        return index + 1
      }
    },
    handleClosePopover() {
      $('body').trigger('click')
    },
    handleSortChange(data) {
      this.$emit('sort-change', data)
    },
    handleCurrentChange(data) {
      this.$emit('row-click', data)
      if (this.options.curRow) {
        this.options.curRow = data
      }
    },
  }
}
</script>

<style lang="less">
// .r-table {
//   .el-table__header-wrapper {
//     thead tr th {
//       background-color: #f5f6f8;
//       color: #000;
//       font-weight: bold;
//       border: none !important;
//     }
//   }
//   .el-table__body-wrapper {
//     tbody tr {
//       color: #000;
//       &:nth-child(even) {
//         background-color: #f3fafd;
//       }
//       td {
//         padding: 5px 0;
//         border: none;
//       }
//     }
//   }
// }
.el-table{
  border-top: 1px solid #DCDFE6;
  border-left: 1px solid #DCDFE6;
  border-right: 1px solid #DCDFE6;
}
.el-table th.el-table__cell{
  background-color: #F2F6FC;
  border-right: 1px solid #DCDFE6;
  &:last-child{
    border-right: none;
  }
}
.el-table td.el-table__cell{
  &:last-child{
    border-right: none;
  }
  border-right: 1px solid #DCDFE6;
  // border-left: 1px solid #DCDFE6;
}
</style>
